import { BaseEntity } from './base-entity';
import { Avatar } from 'bookraw/shared/models/avatar.model';
import { AdultSubscriptions, Subscription } from 'bookraw/shared/models/subscription.model';
import { SchoolClass } from 'bookraw/shared/models/school-class.model';
import { ChildStatistics, UserBookStatistics, UserStatistics } from 'bookraw/shared/models/statistic.model';
import { School } from 'bookraw/shared/models/school.model';
import { Book } from 'bookraw/shared/models/book.model';
import { Badge } from 'bookraw/shared/models/badge.model';
import { AvailableActions } from 'bookraw/shared/models/permission.model';
import { TaxonomyTerm } from 'bookraw/shared/models/taxonomy.model';
import { Partner } from 'bookraw/shared/models/partner.model';
import { UserLexileTest } from 'bookraw/shared/models/user-lexile-test.model';
import { Test } from 'bookraw/shared/models/test.model';
import { UserPlacementTest } from 'bookraw/shared/models/user-placement-test.model';
import { UserBookStatisticsDaily } from 'bookraw/shared/models/user-book-statistics-daily.model';

export enum UserType {
  ADMIN = 'admin',
  ADULT = 'adult',
  CHILD = 'child'
}

export enum UserRole {
  TEACHER = 'teacher',
  OPERATOR = 'operator',
  STUDENT = 'student'
}

export enum UserRealType {
  CHILD = 'child',
  PARENT = 'parent',
  PARTNER = 'partner',
  STUDENT = 'student',
  TEACHER = 'teacher',
  OPERATOR = 'operator',
  TEACHER_PARENT = 'teacher_parent',
  OPERATOR_PARENT = 'operator_parent'
}

export enum LicenceStatus {
  ACTIVE = 'active',
  NOT_YET_STARTED = 'notYetStarted',
  EXPIRED = 'expired',
  MISSING = 'missing',
  INACTIVE = 'inactive',
  REVOKED = 'revoked'
}

export interface UserSchool extends School {
  role: UserRealType | UserRole;
}

export class User extends BaseEntity {
  adult: User;
  parentRegistrationLink: string;
  name: string;
  firstName: string;
  lastName: string;
  username: string;
  accessCode: string;
  type: UserType;
  lexileScore: number;
  transformedLexileScore: string;
  credit: number;
  email: string;
  age: number;
  weeklyReport: boolean;
  avatar: Avatar;
  schoolClasses: SchoolClass[];
  schools: UserSchool[];
  teachers: User[];
  students: User[];
  assignedBooks: Book[];
  assignedBooksWithTimeSpent: Book[];
  lexileTests: UserLexileTest[];
  placementTests: UserPlacementTest[];
  tests: Test[];
  books: Book[];
  hiddenTaxonomyTerms: TaxonomyTerm[];
  subscription: Subscription;
  adultActiveSubscription: AdultSubscriptions;
  adultSubscriptions: AdultSubscriptions[];
  schoolSubscriptions: Subscription[];
  subscriptionOnThisSchool: Subscription;
  statistics: UserStatistics;
  bookStatistics: UserBookStatistics;
  bookStatisticsDaily: UserBookStatisticsDaily;
  childStatistics: ChildStatistics;
  badges: Badge[];
  recentBadges: Badge[];
  badgesCount: number;
  status: string;
  lastLoginAt: string;
  numberOfStudents: number;
  role: UserRole;
  realType: UserRealType;
  children: User[];
  level: TaxonomyTerm;
  birthyear: number;
  partners: Partner[];
  taxonomyTerms: TaxonomyTerm[];
  cefrLevel: string;
}

export interface AuthResponse {
  user: AuthResponseUser;
  settings: {
    upload_limit: number;
  };
  token_type: string;
  expires_in: number;
  access_token: string;
  refresh_token: string;
}

export interface AuthResponseUser extends BaseEntity {
  username: string;
  name: string;
  email: string;
  isFirstLogin: boolean;
  status: LicenceStatus;
  schoolSubscription: Subscription;
  schools: UserSchool[];
  schoolClasses: {
    id: string;
    title: string;
  }[];
  partners: Partner[];
  type: UserType;
  weeklyReport: boolean;
  lastUpdate: number;
  ssoId: number;
  externalGroupId: string;
  can: {
    schools?: {
      [schoolId in number]: {
        [action in AvailableActions]?: {
          [key in 'type' | 'client' | '!fields']?: string[]
        } | [];
      }
    }[];
    partners?: {
      [partnerId in number]: {
        [action in AvailableActions]?: {
        [key in 'type' | 'client' | '!fields']?: string[]
      } | [];
      }
    }[];
    global?: {
      [action in AvailableActions]?: {
        [key in 'type' | 'client' | '!fields']?: string[]
      } | [];
    }
  };
}
